(function () {
    'use strict';
    angular.module('app').controller('HistoryTransactionController', HistoryTransactionController);
    HistoryTransactionController.$Inject = [
        'data',
        '$uibModalInstance',
        'toastr',
        'HistoryTransactionTableService'
    ];

    function HistoryTransactionController(data, $uibModalInstance, toastr, HistoryTransactionTableService) {
        const vm = this;
        vm.transactionData = angular.copy(data);
        vm.company = {};
        vm.subAffiliates = [];
        vm.modalClose = modalClose;


        vm.onSubmit = function (form) {

        }

        init();
        function init() {
            getTransactionHistory();

        }

        function modalClose() {
            $uibModalInstance.dismiss();
        }

        function getTransactionHistory() {
            vm.historyTransactionTable = new HistoryTransactionTableService(vm.transactionData).tableData
        }


    }
})();


// WEBPACK FOOTER //
// ./js/controllers/affiliate-sale/modal/historyTransactionModal.js